// Auto generated from api/portainer.go
// DO NOT MANUALLY EDIT THIS FILE

import { DeepUnion } from '@/types/deepUnion';

export const Authorizations = {
  Azure: {
    Container: {
      Group: {
        Action: 'AzureContainerGroupAction',
        Create: 'AzureContainerGroupCreate',
        Delete: 'AzureContainerGroupDelete',
        Get: 'AzureContainerGroupGet',
      },
      Groups: {
        List: 'AzureContainerGroupsList',
      },
    },
    Provider: {
      Get: 'AzureProviderGet',
    },
    Resource: {
      Group: {
        Get: 'AzureResourceGroupGet',
      },
      Groups: {
        List: 'AzureResourceGroupsList',
      },
    },
    Subscription: {
      Get: 'AzureSubscriptionGet',
    },
    Subscriptions: {
      List: 'AzureSubscriptionsList',
    },
    Undefined: 'AzureUndefined',
  },
  Docker: {
    Agent: {
      Browse: {
        Delete: 'DockerAgentBrowseDelete',
        Get: 'DockerAgentBrowseGet',
        List: 'DockerAgentBrowseList',
        Put: 'DockerAgentBrowsePut',
        Rename: 'DockerAgentBrowseRename',
      },
      Host: {
        Info: 'DockerAgentHostInfo',
      },
      List: 'DockerAgentList',
      Ping: 'DockerAgentPing',
      Undefined: 'DockerAgentUndefined',
    },
    Build: {
      Cancel: 'DockerBuildCancel',
      Prune: 'DockerBuildPrune',
    },
    Config: {
      Create: 'DockerConfigCreate',
      Delete: 'DockerConfigDelete',
      Inspect: 'DockerConfigInspect',
      List: 'DockerConfigList',
      Update: 'DockerConfigUpdate',
    },
    Container: {
      Archive: {
        Info: 'DockerContainerArchiveInfo',
        _index: 'DockerContainerArchive',
      },
      Attach: {
        Websocket: 'DockerContainerAttachWebsocket',
        _index: 'DockerContainerAttach',
      },
      Changes: 'DockerContainerChanges',
      Create: 'DockerContainerCreate',
      Delete: 'DockerContainerDelete',
      Exec: 'DockerContainerExec',
      Export: 'DockerContainerExport',
      Inspect: 'DockerContainerInspect',
      Kill: 'DockerContainerKill',
      List: 'DockerContainerList',
      Logs: 'DockerContainerLogs',
      Pause: 'DockerContainerPause',
      Prune: 'DockerContainerPrune',
      Put: {
        Container: {
          Archive: 'DockerContainerPutContainerArchive',
        },
      },
      Rename: 'DockerContainerRename',
      Resize: 'DockerContainerResize',
      Restart: 'DockerContainerRestart',
      Start: 'DockerContainerStart',
      Stats: 'DockerContainerStats',
      Stop: 'DockerContainerStop',
      Top: 'DockerContainerTop',
      Unpause: 'DockerContainerUnpause',
      Update: 'DockerContainerUpdate',
      Wait: 'DockerContainerWait',
    },
    Distribution: {
      Inspect: 'DockerDistributionInspect',
    },
    Events: 'DockerEvents',
    Exec: {
      Inspect: 'DockerExecInspect',
      Resize: 'DockerExecResize',
      Start: 'DockerExecStart',
    },
    Image: {
      Build: 'DockerImageBuild',
      Commit: 'DockerImageCommit',
      Create: 'DockerImageCreate',
      Delete: 'DockerImageDelete',
      Get: {
        All: 'DockerImageGetAll',
        _index: 'DockerImageGet',
      },
      History: 'DockerImageHistory',
      Inspect: 'DockerImageInspect',
      List: 'DockerImageList',
      Load: 'DockerImageLoad',
      Prune: 'DockerImagePrune',
      Push: 'DockerImagePush',
      Search: 'DockerImageSearch',
      Tag: 'DockerImageTag',
    },
    Info: 'DockerInfo',
    Network: {
      Connect: 'DockerNetworkConnect',
      Create: 'DockerNetworkCreate',
      Delete: 'DockerNetworkDelete',
      Disconnect: 'DockerNetworkDisconnect',
      Inspect: 'DockerNetworkInspect',
      List: 'DockerNetworkList',
      Prune: 'DockerNetworkPrune',
    },
    Node: {
      Delete: 'DockerNodeDelete',
      Inspect: 'DockerNodeInspect',
      List: 'DockerNodeList',
      Update: 'DockerNodeUpdate',
    },
    Ping: 'DockerPing',
    Plugin: {
      Create: 'DockerPluginCreate',
      Delete: 'DockerPluginDelete',
      Disable: 'DockerPluginDisable',
      Enable: 'DockerPluginEnable',
      Inspect: 'DockerPluginInspect',
      List: 'DockerPluginList',
      Privileges: 'DockerPluginPrivileges',
      Pull: 'DockerPluginPull',
      Push: 'DockerPluginPush',
      Set: 'DockerPluginSet',
      Upgrade: 'DockerPluginUpgrade',
    },
    Secret: {
      Create: 'DockerSecretCreate',
      Delete: 'DockerSecretDelete',
      Inspect: 'DockerSecretInspect',
      List: 'DockerSecretList',
      Update: 'DockerSecretUpdate',
    },
    Service: {
      Create: 'DockerServiceCreate',
      Delete: 'DockerServiceDelete',
      Force: {
        Update: {
          Service: 'DockerServiceForceUpdateService',
        },
      },
      Inspect: 'DockerServiceInspect',
      List: 'DockerServiceList',
      Logs: 'DockerServiceLogs',
      Update: 'DockerServiceUpdate',
    },
    Session: {
      Start: 'DockerSessionStart',
    },
    Swarm: {
      Init: 'DockerSwarmInit',
      Inspect: 'DockerSwarmInspect',
      Join: 'DockerSwarmJoin',
      Leave: 'DockerSwarmLeave',
      Unlock: {
        Key: 'DockerSwarmUnlockKey',
        _index: 'DockerSwarmUnlock',
      },
      Update: 'DockerSwarmUpdate',
    },
    System: 'DockerSystem',
    Task: {
      Inspect: 'DockerTaskInspect',
      List: 'DockerTaskList',
      Logs: 'DockerTaskLogs',
    },
    Undefined: 'DockerUndefined',
    Version: 'DockerVersion',
    Volume: {
      Create: 'DockerVolumeCreate',
      Delete: 'DockerVolumeDelete',
      Inspect: 'DockerVolumeInspect',
      List: 'DockerVolumeList',
      Prune: 'DockerVolumePrune',
    },
  },
  Endpoint: {
    Resources: {
      Access: 'EndpointResourcesAccess',
    },
  },
  Helm: {
    Install: {
      Chart: 'HelmInstallChart',
    },
    Repo: {
      Create: 'HelmRepoCreate',
      List: 'HelmRepoList',
    },
    Uninstall: {
      Chart: 'HelmUninstallChart',
    },
  },
  Kubernetes: {
    Access: {
      All: {
        Namespaces: 'K8sAccessAllNamespaces',
      },
      Namespace: {
        Read: 'K8sAccessNamespaceRead',
        Write: 'K8sAccessNamespaceWrite',
      },
      System: {
        Namespaces: 'K8sAccessSystemNamespaces',
      },
      User: {
        Namespaces: 'K8sAccessUserNamespaces',
      },
    },
    Application: {
      Console: {
        ReadWrite: 'K8sApplicationConsoleRW',
      },
      Details: {
        Read: 'K8sApplicationDetailsR',
        Write: 'K8sApplicationDetailsW',
      },
      Error: {
        Details: {
          Read: 'K8sApplicationErrorDetailsR',
        },
      },
      Patch: 'K8sApplicationsP',
    },
    Applications: {
      Advanced: {
        Deployment: {
          ReadWrite: 'K8sApplicationsAdvancedDeploymentRW',
        },
      },
      Read: 'K8sApplicationsR',
      Write: 'K8sApplicationsW',
    },
    Cluster: {
      Node: {
        Read: 'K8sClusterNodeR',
        Write: 'K8sClusterNodeW',
      },
      Read: 'K8sClusterR',
      Role: {
        Bindings: {
          Read: 'K8sClusterRoleBindingsR',
          Write: 'K8sClusterRoleBindingsW',
        },
      },
      Roles: {
        Read: 'K8sClusterRolesR',
        Write: 'K8sClusterRolesW',
      },
      Setup: {
        ReadWrite: 'K8sClusterSetupRW',
      },
      Write: 'K8sClusterW',
    },
    Config: {
      Maps: {
        Read: 'K8sConfigMapsR',
        Write: 'K8sConfigMapsW',
      },
    },
    Cron: {
      Jobs: {
        Read: 'K8sCronJobsR',
        Write: 'K8sCronJobsW',
      },
    },
    Ingresses: {
      Read: 'K8sIngressesR',
      Write: 'K8sIngressesW',
    },
    Jobs: {
      Read: 'K8sJobsR',
      Write: 'K8sJobsW',
    },
    Pod: {
      Delete: 'K8sPodDelete',
      Security: {
        Write: 'OperationK8sPodSecurityW',
      },
    },
    Registry: {
      Secret: {
        Delete: 'K8sRegistrySecretDelete',
        Inspect: 'K8sRegistrySecretInspect',
        List: 'K8sRegistrySecretList',
        Update: 'K8sRegistrySecretUpdate',
      },
    },
    Resource: {
      Pool: {
        Details: {
          Read: 'K8sResourcePoolDetailsR',
          Write: 'K8sResourcePoolDetailsW',
        },
      },
      Pools: {
        Access: {
          Management: {
            ReadWrite: 'K8sResourcePoolsAccessManagementRW',
          },
        },
        Read: 'K8sResourcePoolsR',
        Write: 'K8sResourcePoolsW',
      },
    },
    Role: {
      Bindings: {
        Read: 'K8sRoleBindingsR',
        Write: 'K8sRoleBindingsW',
      },
    },
    Roles: {
      Read: 'K8sRolesR',
      Write: 'K8sRolesW',
    },
    Secrets: {
      Read: 'K8sSecretsR',
      Write: 'K8sSecretsW',
    },
    Service: {
      Accounts: {
        Read: 'K8sServiceAccountsR',
        Write: 'K8sServiceAccountsW',
      },
    },
    Services: {
      Read: 'K8sServicesR',
      Write: 'K8sServicesW',
    },
    Storage: {
      Class: {
        Disabled: {
          Read: 'K8sStorageClassDisabledR',
        },
      },
    },
    Undefined: 'K8sUndefined',
    Volume: {
      Details: {
        Read: 'K8sVolumeDetailsR',
        Write: 'K8sVolumeDetailsW',
      },
    },
    Volumes: {
      Read: 'K8sVolumesR',
      Write: 'K8sVolumesW',
    },
    YAMLR: 'K8sYAMLR',
    YAMLW: 'K8sYAMLW',
  },
  Portainer: {
    Docker: {
      Hub: {
        Inspect: 'PortainerDockerHubInspect',
        Update: 'PortainerDockerHubUpdate',
      },
    },
    Endpoint: {
      Create: 'PortainerEndpointCreate',
      Delete: 'PortainerEndpointDelete',
      Extension: {
        Add: 'PortainerEndpointExtensionAdd',
        Remove: 'PortainerEndpointExtensionRemove',
      },
      Group: {
        Access: 'PortainerEndpointGroupAccess ',
        Create: 'PortainerEndpointGroupCreate',
        Delete: 'PortainerEndpointGroupDelete',
        Inspect: 'PortainerEndpointGroupInspect',
        List: 'PortainerEndpointGroupList',
        Update: 'PortainerEndpointGroupEdit',
      },
      Inspect: 'PortainerEndpointInspect',
      Job: 'PortainerEndpointJob',
      List: 'PortainerEndpointList',
      Snapshot: 'PortainerEndpointSnapshot',
      Snapshots: 'PortainerEndpointSnapshots',
      Update: {
        Access: 'PortainerEndpointUpdateAccess',
        Settings: 'PortainerEndpointUpdateSettings',
        _index: 'PortainerEndpointUpdate',
      },
    },
    Extension: {
      Create: 'PortainerExtensionCreate',
      Delete: 'PortainerExtensionDelete',
      Inspect: 'PortainerExtensionInspect',
      List: 'PortainerExtensionList',
      Update: 'PortainerExtensionUpdate',
    },
    MOTD: 'PortainerMOTD',
    Registry: {
      Configure: 'PortainerRegistryConfigure',
      Create: 'PortainerRegistryCreate',
      Delete: 'PortainerRegistryDelete',
      Inspect: 'PortainerRegistryInspect',
      Internal: {
        Delete: 'PortainerRegistryInternalDelete',
        Update: 'PortainerRegistryInternalUpdate',
      },
      List: 'PortainerRegistryList',
      Update: {
        Access: 'PortainerRegistryUpdateAccess',
        _index: 'PortainerRegistryUpdate',
      },
    },
    Resource: {
      Control: {
        Create: 'PortainerResourceControlCreate',
        Delete: 'PortainerResourceControlDelete',
        Update: 'PortainerResourceControlUpdate',
      },
    },
    Role: {
      Create: 'PortainerRoleCreate',
      Delete: 'PortainerRoleDelete',
      Inspect: 'PortainerRoleInspect',
      List: 'PortainerRoleList',
      Update: 'PortainerRoleUpdate',
    },
    Schedule: {
      Create: 'PortainerScheduleCreate',
      Delete: 'PortainerScheduleDelete',
      File: 'PortainerScheduleFile',
      Inspect: 'PortainerScheduleInspect',
      List: 'PortainerScheduleList',
      Tasks: 'PortainerScheduleTasks',
      Update: 'PortainerScheduleUpdate',
    },
    Settings: {
      Inspect: 'PortainerSettingsInspect',
      LDAPCheck: 'PortainerSettingsLDAPCheck',
      Update: 'PortainerSettingsUpdate',
    },
    Stack: {
      Create: 'PortainerStackCreate',
      Delete: 'PortainerStackDelete',
      File: 'PortainerStackFile',
      Inspect: 'PortainerStackInspect',
      List: 'PortainerStackList',
      Migrate: 'PortainerStackMigrate',
      Update: 'PortainerStackUpdate',
    },
    Tag: {
      Create: 'PortainerTagCreate',
      Delete: 'PortainerTagDelete',
      List: 'PortainerTagList',
    },
    Team: {
      Create: 'PortainerTeamCreate',
      Delete: 'PortainerTeamDelete',
      Inspect: 'PortainerTeamInspect',
      List: 'PortainerTeamList',
      Membership: {
        Create: 'PortainerTeamMembershipCreate',
        Delete: 'PortainerTeamMembershipDelete',
        List: 'PortainerTeamMembershipList',
        Update: 'PortainerTeamMembershipUpdate',
      },
      Memberships: 'PortainerTeamMemberships',
      Update: 'PortainerTeamUpdate',
    },
    Template: {
      Create: 'PortainerTemplateCreate',
      Delete: 'PortainerTemplateDelete',
      Inspect: 'PortainerTemplateInspect',
      List: 'PortainerTemplateList',
      Update: 'PortainerTemplateUpdate',
    },
    Undefined: 'PortainerUndefined',
    Upload: {
      TLS: 'PortainerUploadTLS',
    },
    User: {
      Create: {
        Git: {
          Credential: 'PortainerUserCreateGitCredential',
        },
        Token: 'PortainerUserCreateToken',
        _index: 'PortainerUserCreate',
      },
      Delete: {
        Git: {
          Credential: 'PortainerUserDeleteGitCredential',
        },
        _index: 'PortainerUserDelete',
      },
      Inspect: {
        Git: {
          Credential: 'PortainerUserInspectGitCredential',
        },
        _index: 'PortainerUserInspect',
      },
      List: {
        Git: {
          Credential: 'PortainerUserListGitCredential',
        },
        Token: 'PortainerUserListToken',
        _index: 'PortainerUserList',
      },
      Memberships: 'PortainerUserMemberships',
      Revoke: {
        Token: 'PortainerUserRevokeToken',
      },
      Update: {
        Git: {
          Credential: 'PortainerUserUpdateGitCredential',
        },
        Password: 'PortainerUserUpdatePassword',
        _index: 'PortainerUserUpdate',
      },
    },
    Webhook: {
      Create: 'PortainerWebhookCreate',
      Delete: 'PortainerWebhookDelete',
      List: 'PortainerWebhookList',
    },
    Websocket: {
      Exec: 'PortainerWebsocketExec',
    },
  },
} as const;

export type Authorization = DeepUnion<typeof Authorizations>;
